import React from 'react';
import PropTypes from 'prop-types';
import CurrencyCodeAdd from '@/components/common/CurrencyCodeAdd';

const OutstandingCreditList = ({ rows = [] }) => {
  if (!rows.length) return null;
  return (
    <div className="mb-8">
      <h4 className="font-semibold mb-3">Unpaid Credit Orders</h4>
      <ul className="space-y-2">
        {rows.map((o) => (
          <li key={o._id} className="flex justify-between items-center text-sm p-3 bg-yellow-50 rounded-xl">
            <span className="font-medium">#{o.order_serial_no}</span>
            <CurrencyCodeAdd price={o.total} />
          </li>
        ))}
      </ul>
    </div>
  );
};

OutstandingCreditList.propTypes = { rows: PropTypes.array };
export default OutstandingCreditList;
